import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import { createGameConfig } from '../ironkeep/config';

/**
 * Ironkeep page component.
 * Mounts a full-viewport Phaser 3 game instance and tears it down on unmount.
 */
export default function Ironkeep() {
  const containerRef = useRef(null);
  const gameRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const config = createGameConfig(containerRef.current);
    gameRef.current = new Phaser.Game(config);

    return () => {
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        background: '#1a1a2e',
        touchAction: 'none',
      }}
    />
  );
}
